module.exports = __webpack_public_path__ + "static/media/sam.f519edff.png";